import Phaser from "phaser";
import { COLORS, GAME_HEIGHT, GAME_WIDTH } from "../config";
import { AudioFx } from "./AudioFx";

/**
 * The placebo / healing layer: sparkle dissolves, gentle chimes, and a screen
 * inflammation tint that recedes from red toward clear as the region is cleaned.
 */
export default class HealingFeedback {
  private scene: Phaser.Scene;
  private sparkles: Phaser.GameObjects.Particles.ParticleEmitter;
  private inflammation: Phaser.GameObjects.Rectangle;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;

    // Full-screen inflamed overlay. Starts visible, fades as things are cleared.
    this.inflammation = scene.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, COLORS.inflamed, 0.0)
      .setScrollFactor(0) // pin to the viewport (the world scrolls beneath it)
      .setDepth(50)
      .setBlendMode(Phaser.BlendModes.MULTIPLY);

    this.sparkles = scene.add
      .particles(0, 0, "sparkle", {
        speed: { min: 40, max: 140 },
        scale: { start: 0.9, end: 0 },
        alpha: { start: 1, end: 0 },
        lifespan: { min: 400, max: 700 },
        quantity: 0,
        emitting: false,
        blendMode: Phaser.BlendModes.ADD,
        tint: COLORS.sparkle,
      })
      .setDepth(60);
  }

  /** Sparkle pop + chime where a pathogen finished digesting. */
  digestBurst(x: number, y: number, comboIndex: number): void {
    this.sparkles.emitParticleAt(x, y, 10);
    AudioFx.digestChime(comboIndex);
  }

  /** t in [0..1]: 1 = fully inflamed (level start), 0 = clear. */
  setInflammation(t: number): void {
    const target = Phaser.Math.Clamp(t, 0, 1) * 0.5;
    this.scene.tweens.add({
      targets: this.inflammation,
      alpha: target,
      duration: 600,
      ease: "Sine.easeOut",
    });
  }

  destroy(): void {
    this.sparkles.destroy();
    this.inflammation.destroy();
  }
}
